import { Box, Text, HStack, Skeleton } from "@chakra-ui/react";
import React, { useState, useEffect, useRef, useContext } from "react";
import { api } from "../../services/api";
import { ProductCard } from "../../components/ProductCard";
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { AddToCartPopUp } from "../AddToCartPopUp";
import { CartContext } from "../../Context/CartContext";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const CustomPrevArrow = ({ className, style, onClick }) => (
  <div
    className={className}
    style={{
      ...style,
      display: "block",
      background: "#ff7e15", // Custom color for the previous arrow
      borderRadius: "50%",
      zIndex: 1,
    }}
    onClick={onClick}
  />
);

const CustomNextArrow = ({ className, style, onClick }) => (
  <div
    className={className}
    style={{
      ...style,
      display: "block",
      background: "#ff7e15", // Custom color for the next arrow
      borderRadius: "50%",
      zIndex: 10000,
    }}
    onClick={onClick}
  />
);

export function ProductsCarousel({ typeName, products }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [products, setProducts] = useState([]);
  // const [productTypes, setProductTypes] = useState([]);
  const carouselRef = useRef(null);
  const { showCartPopUp, setShowCartPopUp} = useContext(CartContext)
  const sliderRef = useRef();

  // async function fetchProducts() {
  //   const response = await api.get(`/?type=${encodeURIComponent(typeName)}`);
  //   setProducts(response.data.products);
  //   setProductTypes(response.data.product_types);
  // }

  // useEffect(() => {
  //   fetchProducts();
  // }, []);

  useEffect(() => {
    if (sliderRef.current && window.innerWidth <= 768) {
      sliderRef.current.slickGoTo(0); // Force the slider to go to the first slide
    }
  }, [products]);


  // const settings = {
  //   dots: true,
  //   infinite: false,
  //   speed: 500,
  //   slidesToShow: 6,
  //   slidesToScroll: 3,
  //   initialSlide: 0,
  //   nextArrow: <CustomNextArrow />,
  //   prevArrow: <CustomPrevArrow />,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 5,
  //         slidesToScroll: 3,
  //         infinite: true,
  //         dots: true,
  //         initialSlide: 0,

  //       }
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //         initialSlide: 1,

  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //         initialSlide: 1,

  //       }
  //     }
  //   ],
  //   appendDots: dots => (
  //     <div
  //       style={{
  //         backgroundColor: "transparent",
  //         borderRadius: "10px",
  //         padding: "10px",
  //         bottom: '0px'
  //       }}
  //     >
  //       <ul style={{ margin: "0px" }}> {dots} </ul>
  //     </div>
  //   ),
  // };

  const settings = {
  dots: true,
  infinite: false,
  speed: 400,
  slidesToShow: 5,
  slidesToScroll: 5,
  arrows: window.innerWidth > 768,

  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
      }
    }
  ],
  appendDots: dots => (
    <div
      style={{
        paddingTop: "10px",
        paddingBottom: "10px",
      }}
    >
      <ul
        style={{
          margin: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {dots}
      </ul>
    </div>
  )
};

  if (!products || products.length === 0) {
    return (
      <Box
        display="grid"
        gridTemplateColumns={{ base: "repeat(2,1fr)", md: "repeat(3,1fr)", lg: "repeat(4,1fr)", xl: "repeat(5,1fr)" }}
        gap={{ base: "12px", md: "20px" }}
        px={{ base: "0px", md: "10px" }}
        pb={{ base: "35px", md: "30px" }}
      >
        {Array.from({ length: 5 }).map((_, i) => (
          <Box key={i} borderRadius="16px" overflow="hidden">
            <Skeleton height={{ base: "120px", md: "160px" }} borderRadius="16px 16px 0 0" />
            <Box p="12px" bg="white" borderRadius="0 0 16px 16px" border="1px solid rgba(0,74,51,0.08)" borderTop="none">
              <Skeleton height="14px" mb="8px" borderRadius="6px" />
              <Skeleton height="12px" width="60%" mb="16px" borderRadius="6px" />
              <Skeleton height="18px" width="80px" borderRadius="6px" />
            </Box>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box
      w="100%"
      position="relative"
      overflow="hidden"
      px={{ base: "0px", md: "10px" }}
      pb={{ base: "35px", md: "30px" }}
      sx={{
        ".slick-dots": {
          bottom: "-5px",
        },

        ".slick-dots li": {
          margin: "0 2px",
        },

        ".slick-dots li button:before": {
          color: "#fc8f04",
          fontSize: "10px",
          opacity: 0.35,
        },

        ".slick-dots li.slick-active button:before": {
          color: "#004a33",
          opacity: 1,
        },
      }}
    >
      <Slider ref={sliderRef} {...settings}>
        {products?.map((product, index) => (
          <Box
            key={product.id}
            margin="15px 0px"
            // padding="30px 5px"
            padding={{
              base: "10px 6px",
              md: "20px 10px"
            }}
          >
            <Link to={`/produtos/${product.productType?.name.replace(/(%20|\s+)/g, "+")}/${product.name?.replace(/(%20|\s+)/g, "+")}`}>
              <ProductCard
                product={product}
                id={product.id}
                name={product.name}
                prices={product.prices}
                brand={product.brand}
                size={product.size}
                description={product.description}
                quantityPerBox={product.quantity_per_box}
                marketPrice={product.market_price}
                productType={product.product_type}
                batch={product.batch}
                productPhotoUrl={product.photo}
                carouselType={typeName}
              />
            </Link>
          </Box>
        ))}
      </Slider>
      {showCartPopUp && <AddToCartPopUp />}
    </Box>
  );
}
